export enum Channel {
  Subscriptions = 'Subscriptions',
  Tips = 'Tips',
  Posts = 'Posts',
  Messages = 'Messages',
  Referrals = 'Referrals',
  Streams = 'Streams',
}

export const earningChannels = [
  Channel.Subscriptions,
  Channel.Tips,
  Channel.Posts,
  Channel.Messages,
]